import { ArrowLeft, Check } from 'lucide-react';

/** "Back to Care Plans" link rendered at the top of the FP results page. */
export const BackLink = ({ onBack }: { onBack: () => void }) => (
  <button
    type="button"
    onClick={onBack}
    className="inline-flex items-center gap-1 text-sm text-sage transition-colors duration-150 ease-out hover:text-[hsl(169_95%_18%)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-emphasis"
  >
    <ArrowLeft className="h-4 w-4" aria-hidden />
    Back to Care Guides
  </button>
);

/**
 * Two-step "Your Story -> Your Matches" indicator that sits in the
 * results-page header. The first step is always shown as complete (the FP
 * just finished it) and the second as current.
 */
export const Stepper = () => (
  <div className="flex items-center gap-3 text-sm">
    <span className="flex items-center gap-2 text-text-secondary">
      <span className="flex h-6 w-6 items-center justify-center rounded-full bg-sage text-white">
        <Check className="h-3 w-3" aria-hidden />
      </span>
      Your Story
    </span>
    <span className="h-px w-12 bg-border-subtle" aria-hidden />
    <span className="flex items-center gap-2 font-medium text-text-primary">
      <span className="flex h-6 w-6 items-center justify-center rounded-full bg-sage text-xs font-semibold text-white">
        2
      </span>
      Your Matches
    </span>
  </div>
);
